import nextAction from "model/actions/utilities/nextAction";
import takeMap from "model/actions/story/takeMap";

const farmhand = (onDone) => ({
  title: "the farmhand",
  description: [
    "my hands will not open all the way. the crew has a jug going in the yard",
    "a man drops down beside me. it takes him two tries to sit",
    "\"yer seemin' hearty... unlike yer friend there.\" he nods at a pile of rags against the wall",
  ],
  buttons: [nextAction("Friend", () => onDone(strangerDrunk(onDone)))],
});

const strangerDrunk = (onDone) => ({
  title: "the farmhand",
  description: [
    "a closer look at the rags. there is a man inside them",
    '"that one. the priest. from yer caravan."',
    '"my caravan?"',
    '"he aint with you? yous both came from same way a few days apart. both haunted alike"',
    '"who is he? what do you know about him?"',
    'a shrug. "not much. was a priest of some sort. now he just blubbers about some nasty business with a caravan."',
  ],
  buttons: [nextAction("Business", () => onDone(strangerDrunkEnd(onDone)))],
});

const strangerDrunkEnd = (onDone) => ({
  title: "the farmhand",
  description: [
    "\"some fellas went rotten and killed er'body. women and chi'ren too.\"",
    "\"he musta seen some things. reckon he can't sleep sober on account of the nightmares. his god aint lettin' him rest\"",
    '"what else?"',
    '"sold me this paper for a few coins. \'ere, you take it. aint no use to me. i aint no chaser of ghosts"',
    "he puts it in my hand and goes back to the jug",
  ],
  buttons: [takeMap(onDone)],
});
export default farmhand;
